export enum LabelIcon {
  Count = 'layers-stacked',
  Duration = 'clock-circle',
  Price = 'currency-dollar',
}
